module.exports = "\nbutton {\n  margin: 60px 0;\n}\n\ni {\n  margin-right: 5px;\n}\n\n.home-logo {\n  margin-bottom: 120px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home.component.css
// module id = ./src/app/components/home.component.css
// module chunks = main